import { Component } from 'react'
import Icon from '../../Nodes/Icon'
import Snackbar from '../../Widgets/Snackbar'
import { replaceAll, copyToClipboard } from '../../../utilities'

class CodeDisplay extends Component {
    state = {
        snackbarOpen: false
    }

    formatHtmlForDisplay = code => replaceAll(code, { '<': '&lt;', '>': '&gt;', '\n': '<br\\>', '  ': '&nbsp;&nbsp;' })

    handleCopy = () => {
        copyToClipboard(this.props.html)
        this.setState({ snackbarOpen: true })
    }

    render() {
        return (
            <code className={'code ' + this.props.className}>
                <span dangerouslySetInnerHTML={{ __html: this.formatHtmlForDisplay(this.props.html) }}></span>
                <button className="code__copy"
                    title="Copy to Clipboard"
                    onClick={this.handleCopy}>
                    <Icon>file_copy</Icon>
                </button>
                <Snackbar 
                    open={this.state.snackbarOpen}
                    onClose={() => this.setState({ snackbarOpen: false })}>
                    Copied to clipboard
                </Snackbar>
            </code>
        )
    }
}

export default CodeDisplay